import { useRef, useEffect, ComponentProps, useCallback, useMemo } from 'react';
import {
  ChatList,
  ChatListRef,
  statusTransform,
} from '@src/components/common/chat-list';
import {
  StreamStatus,
  useMessageModel,
  generateThreadId,
  CreateThreadParams,
} from './hooks/useMessageModel';
import ChatBox from '@src/components/pc/Claw/chat/Chatbox';
import { useParams } from 'react-router-dom';
import useClawWsStore from '@src/stores/useClawWsStore';
import { buildClawAgentSessionKey } from '@src/hooks/useClawWs';
interface NewChatProps {
  agentId: string;
  agentChip?: ComponentProps<typeof ChatBox>['agentChip'];
  disabled?: ComponentProps<typeof ChatBox>['disabled'];
  onChatBoxClick?: ComponentProps<typeof ChatBox>['onClick'];
  onCreateThread: (params: CreateThreadParams) => void;
  shareMode?: boolean;
  onExitShare?: () => void;
}
export default function NewChat({
  agentId,
  agentChip,
  disabled = false,
  onChatBoxClick,
  onCreateThread,
  shareMode,
  onExitShare,
}: NewChatProps) {
  const {
    state,
    onRetry,
    onRefresh,
    setThreadId,
    setAgentId,
    onScrollHandler,
    onSendMessage,
    isNewCreatePending,
    updateScrollElRef,
  } = useMessageModel();
  const currentSessionKey = useClawWsStore((s) => s.currentSessionKey);
  const { sessionKey: threadId } = useParams();
  const shareSessionKey = useMemo(() => {
    if (currentSessionKey) return currentSessionKey;
    if (agentId && threadId) return buildClawAgentSessionKey(agentId, threadId);
    return undefined;
  }, [currentSessionKey, agentId, threadId]);
  const chatListRef = useRef<ChatListRef | null>(null);
  // const threadId = '4a3eac58-0777-48df-8714-cad8152b3644';
  // 刷新消息列表
  useEffect(() => {
    if (agentId) {
      setAgentId(agentId);
      if (threadId) {
        setThreadId(false, threadId);
        onRefresh(threadId);
        chatListRef.current?.clearEditor();
      } else {
        setThreadId(true, generateThreadId());
      }
    }
  }, [threadId, onRefresh, setThreadId, agentId]);

  const status = statusTransform({
    isLoading: state.isLoading,
    isError: state.isError,
    hasMore: state.hasMore,
    listLength: state.list.length,
  });

  console.log('state', state);

  const onSendMessageHandler = useCallback(
    (content: string) => {
      onSendMessage(content, onCreateThread);
    },
    [onSendMessage, onCreateThread],
  );

  return (
    <ChatList
      status={status}
      hideHeader={true}
      list={state.list}
      agentChip={agentChip}
      disabled={disabled}
      onChatBoxClick={onChatBoxClick}
      isShowPlaceholder={isNewCreatePending}
      isShowStream={state.streamStatus !== StreamStatus.NONE}
      streamInfo={{
        streamStatus: state.streamStatus,
        message: state.streamMessage ?? {},
      }}
      onRetry={onRetry}
      onScroll={onScrollHandler}
      setScrollRef={updateScrollElRef}
      onSendMessage={onSendMessageHandler}
      shareMode={shareMode}
      onExitShare={onExitShare}
      shareSessionKey={shareSessionKey}
    />
  );
}
